import { ChronicDiseaseSimple } from '@dreryk/egabinet-patient-medical-information-frontend-api';

import { StyledFlex } from '@dreryk/react-components';

import { protectFeature } from '~libs.shared.system';

import { StyledDiagnosesFormTab } from './DiagnosesFormTab.styled';
import { DiagnosesController } from './DiagnosesFormTab.types';
import { ChronicDiseasesCopyAction } from './interactiveTable/ChronicDiseasesCopyAction';
import { DiagnosesInteractiveTable } from './interactiveTable/DiagnosesInteractiveTable';
import { DiagnosesInteractiveTablePlaceholder } from './interactiveTable/DiagnosesInteractiveTablePlaceholder';
import { DiagnosesInteractiveTableSelector } from './interactiveTable/DiagnosesInteractiveTableSelector';
import { RemovalChronicDiseaseModalEventListener } from './interactiveTable/removalChronicDisease/RemovalChronicDiseaseModalEventListener';

type DiagnosesFormTabProps = Pick<DiagnosesController, 'register'> & {
   readonly visitId: number;
   readonly dictionaryValidOn: Date;
   readonly chronicDiseases: ChronicDiseaseSimple[];
};

export const DiagnosesFormTab = (props: DiagnosesFormTabProps): JSX.Element => {
   const creatingMedicalDocumentsAvailable = protectFeature('creatingMedicalDocuments');
   const chronicDiseasesAvailable = Boolean(props.chronicDiseases.length);

   return (
      <StyledDiagnosesFormTab>
         <DiagnosesInteractiveTable
            visitId={props.visitId}
            header={
               <StyledFlex gap={'4px'} alignItems={'center'}>
                  <DiagnosesInteractiveTableSelector
                     register={props.register}
                     dictionaryValidOn={props.dictionaryValidOn}
                     required={creatingMedicalDocumentsAvailable}
                  />
                  {chronicDiseasesAvailable ? (
                     <ChronicDiseasesCopyAction chronicDiseases={props.chronicDiseases} />
                  ) : null}
               </StyledFlex>
            }
            placeholder={
               <DiagnosesInteractiveTablePlaceholder visitId={props.visitId} chronicDiseases={props.chronicDiseases} />
            }
            register={props.register}
            required={creatingMedicalDocumentsAvailable}
            chronicEditable={creatingMedicalDocumentsAvailable}
         />

         <RemovalChronicDiseaseModalEventListener visitBeginDate={props.dictionaryValidOn} />
      </StyledDiagnosesFormTab>
   );
};
